
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import { SchedulablePresenter, CategoryPresenter, OutletPresenter } from 'shared/presenters';
import widgetRoutes from 'enums/routes';
import capitalizeFirstLetter from 'shared/helpers/capitalizeFirstLetter';
import { defined } from 'shared/presenters/presenter';
import GoogleStructuredDataBreadcrumb from 'library/molecules/GoogleStructuredData/GoogleStructuredDataBreadcrumbs';
export interface BreadcrumbStructureProps {
    widgetSlug: string;
    categorySlug?: string;
    outlet: OutletPresenter;
    activity: SchedulablePresenter;
}
const StructuredDataBreadcrumbForActivity = ({ widgetSlug, categorySlug, outlet, activity }: BreadcrumbStructureProps) => {
    const rootItem = {
        link: `${widgetRoutes.HOME.url({ widgetSlug })}`,
        name: `${outlet.name}`,
        image: `${outlet.logoImageURL()}`
    };
    let categoryItem = undefined;
    if (categorySlug) {
        const category = new CategoryPresenter(activity?.category ? activity.category : {});
        categoryItem = {
            link: `${widgetRoutes.CATEGORY.url({ widgetSlug, categoryId: categorySlug })}`,
            name: `${category.name() || capitalizeFirstLetter(categorySlug as string)}`,
            image: `${category.imageURL()}`
        };
    }
    const activityItem = {
        link: `${widgetRoutes.ACTIVITY.url({ activitySlug: defined(activity.slug), categorySlug: categorySlug, widgetSlug })}`,
        name: `${activity.name()}`,
        image: `${activity.imageURL()}`
    };
    const articleBreadcrumbStructuredData = categoryItem
        ? [rootItem, categoryItem, activityItem]
        : [rootItem, activityItem];
    return (<GoogleStructuredDataBreadcrumb breadcrumbs={articleBreadcrumbStructuredData}/>);
};
export default StructuredDataBreadcrumbForActivity;

    async function __Next_Translate__getStaticProps__1966c8dfbb3__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'library//Activity/StructuredDataBreadcrumbForActivity',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1966c8dfbb3__ as getStaticProps }
  